import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  
  //teste
  // apiKey: "AIzaSyDxrGkFT2uHjwsyY-y6xHmQvD8eD9f5yk0",
  // authDomain: "megadeouroproducao.firebaseapp.com",
  // projectId: "megadeouroproducao",
  // storageBucket: "megadeouroproducao.appspot.com",
  // messagingSenderId: "629603967108",
  // appId: "1:629603967108:web:2086d4991f671d57f2e2d1",
  // measurementId: "G-JC6E25DGBD"


// producao

apiKey: "AIzaSyBsnpzMHPPTPuXh_AyIwo24HFAR4j7cAWg",
authDomain: "megadeouro-a14e3.firebaseapp.com",
projectId: "megadeouro-a14e3",
storageBucket: "megadeouro-a14e3.appspot.com",
messagingSenderId: "467747231759",
appId: "1:467747231759:web:29d8e577acba57597a6b7a",
measurementId: "G-WYG0FJ7ESY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app)
const auth = getAuth(app)

export { db, auth }